import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const InspectHeader = ({ children, className }) => (
  <div styleName="inspect-header" className={className}>
    {children}
  </div>
);

InspectHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

InspectHeader.defaultProps = {
  children: null,
  className: '',
};

export default InspectHeader;
